module.exports = __webpack_public_path__ + "img/psql.133c8c2b.png";